import React from 'react';
import styled from 'styled-components';
import { Subtitle, SubtitleH3, Wrapper, CardContainer, TextContainer, CardImg } from '../../styles';

const Card = props => {
    return (
        <Wrapper target='_blank' href={props.link}>
            <CardContainer>
                <CardImg src={props.image} alt={props.label}/>
            </CardContainer>
            <TextContainer>
                <h3>{props.label}</h3>
                <p>{props.text}</p>
            </TextContainer>
        </Wrapper>
    );
}

export default Card;
